export const chatData = {
  header: [{ message: 'E aí, ProAluno. Em que posso ajudar?' }],
  options: [
    {
      message: 'Central do aluno',
      link: 'https://atendimento.proenem.com.br/'
    },
    {
      message: 'Central de vendas',
      link: 'https://api.whatsapp.com/send?phone=5521995481656&text=Quero%20ser%20ProAluno!'
    }
  ]
}
